<template>
  <!-- Static sidebar for desktop -->
  <div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div class="flex flex-col grow bg-primary-8 pt-5 pb-4">
      <div class="flex items-center justify-center shrink-0 m-5">
        <NuxtLink to="/">
          <FoundersPledgeLogo class="h-12 w-auto text-primary" />
        </NuxtLink>
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import FoundersPledgeLogo from '~/../member-webapp-shared/components/fp-logos/FoundersPledgeLogo.vue'
</script>
